module.exports = __webpack_public_path__ + "img/icon-white-27.21092ca5.svg";